/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCallinStatusLookup.ts            *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/callin-status-lookup";

export class AutogenModelCallinStatusLookup<RowType extends ModelRow> extends Endpoint<RowType, RowCallinStatusLookupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCallinStatusLookup extends ModelRow<RowCallinStatusLookupFields> {
	constructor(values?: Partial<RowCallinStatusLookupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCallinStatusLookupFields {
	company_id: string;
	descr: string;
	id: string;
}

